import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatMenuModule } from "@angular/material/menu";
import type { NgBlockUI } from "ng-block-ui";
import { BlockUI, BlockUIModule } from "ng-block-ui";
import { BehaviorSubject, Observable } from "rxjs";

@Component({
    selector: "app-common-component",
    standalone: true,
    template: ``,
    imports: [BlockUIModule, MatCardModule, MatButtonModule, MatMenuModule]
})
export abstract class CommonComponent {
  // #region Properties (5)

  private _isLoading = new BehaviorSubject<boolean>(false);

  public backgroundRefresh: boolean = false;
  @BlockUI() public blockUI!: NgBlockUI;
  public hasData: boolean = false;
  public isLoading$: Observable<boolean> = this._isLoading.asObservable();

  // #endregion Properties (5)

  // #region Constructors (1)

  constructor() {
    this.isLoading$.subscribe((state) => {
      if (!this.backgroundRefresh) {
        state ? this.blockUI.start() : this.blockUI.stop();
      }
    });
  }

  // #endregion Constructors (1)

  // #region Public Methods (1)

  public isLoading(state: boolean) {
    this._isLoading.next(state);
  }

  // #endregion Public Methods (1)
}
